import { render, staticRenderFns } from "./CartBlock.vue?vue&type=template&id=5945740a&lang=pug&"
import script from "./CartBlock.vue?vue&type=script&lang=js&"
export * from "./CartBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports